const clientDevices =  ["Desktop - Windows",
    "Desktop - macOS",
    "Desktop - Linux",
    "Desktop - CrOS",
    "Mobile - Windows Phone",
    "Mobile - Android",
    "Mobile - iOS"];

export default clientDevices;